import React from "react";
import PropTypes from "prop-types";
import PhotoViewer from "./PhotoViewer";
import classNames from "classnames";
import { useTransition } from "react-spring";
import { Icon } from "@accessdev/arc-ui-react";
import "./OfferPhotos.scss";
import { Trans } from "@lingui/react/macro";

function OfferPhotos({ photos }) {
  const [photoViewerActive, setPhotoViewerActive] = React.useState(false);
  const [photoInViewer, setPhotoInViewer] = React.useState(null);
  const [viewerClosing, setViewerClosing] = React.useState(false);

  const animationTime = 300;
  const viewerImgHeight = 300;
  const containerOpenHeight = viewerImgHeight + 105;

  const photoViewerTransition = useTransition(photoInViewer, {
    from: {
      opacity: 0,
      top: "0px",
      transform: !photoViewerActive ? "scale(0)" : "scale(1)",
    },
    enter: {
      opacity: 1,
      top: "0px",
      transform: "scale(1)",
    },
    leave: {
      opacity: 0,
      top: !photoViewerActive || viewerClosing ? "-150px" : "0px",
      transform: !photoViewerActive || viewerClosing ? "scale(0)" : "scale(1)",
    },
    config: { duration: animationTime },
  });

  const handleViewerOpen = (photo) => {
    setPhotoInViewer(photo);
    setTimeout(() => {
      setPhotoViewerActive(true);
    }, animationTime);
  };

  const handleViewerClose = () => {
    setViewerClosing(true);
    setTimeout(() => {
      setPhotoInViewer(null);
    }, 30);
    setTimeout(() => {
      setPhotoViewerActive(false);
      setViewerClosing(false);
    }, animationTime);
  };

  return (
    <section className="offer-photos">
      <h3 className="offer-photos-header">
        <Trans>Photos</Trans>
        <span
          style={{ transition: `${animationTime}ms` }}
          className={classNames("offer-photos__photo-viewer_close", {
            open: !!photoInViewer,
          })}
        >
          <Icon type="button" icon="close" onClick={handleViewerClose} />
        </span>
      </h3>

      <div
        style={{
          transition: `${animationTime}ms`,
          height: !!photoInViewer ? containerOpenHeight : "100px",
        }}
        className="offer-photos__photo-viewer_container"
      >
        {photoViewerTransition(
          (styleProps, item) =>
            item && (
              <PhotoViewer
                animatedStyle={styleProps}
                photo={photoInViewer}
                closeViewer={handleViewerClose}
                imgHeight={viewerImgHeight}
                key={item}
              />
            ),
        )}
        <div className="offer-photos__list">
          {photos.map((photo) => (
            <button
              className="offer-photos__photo"
              key={photo}
              onClick={() => handleViewerOpen(photo)}
            >
              <img src={photo} alt="" />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

OfferPhotos.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default OfferPhotos;
